/* eslint class-methods-use-this: 0 */

const settingsWindowId = "cookie-consent-settings";

const acceptSettingsClass = "cookie-consent-settings__accept-btn";
const acceptSettingsSelector = ".cookie-consent-settings__accept-btn";

export default class SettingsWindow {
    /**
     *
     * @param {Status} status
     * @param {Configuration} configuration
     */
    constructor(status, configuration) {
        this.status = status;
        this.cookieCategories = configuration.Categories;
        this.configuration = configuration;
    }

    show(parent) {
        const settings = document.createElement("div");
        settings.id = settingsWindowId;

        const config = {
            header: this.configuration.CookieSettingsHeader,
            text: this.configuration.CookieSettingsDescription,
            acceptText: this.configuration.cookieSettingsConfirm,
            legalNoticeLink: this.configuration.LegalNoticeLink,
            legalNoticeText: this.configuration.LegalNoticeText,
        };
        settings.innerHTML = this.html(config);
        parent.insertBefore(settings, parent.firstChild);

        document.getElementsByClassName("cookie-consent-settings")[0].focus();

        const selectBtns = Array.prototype.slice.call(document.querySelectorAll(".cookie-settings__category-selection"));
        selectBtns.forEach((element) => {
            element.addEventListener("keydown", function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    element.click();
                }
            });
        });
        const closeSettingsBtns = Array.prototype.slice.call(document.querySelectorAll(acceptSettingsSelector));
        closeSettingsBtns.forEach((element) => {
            element.addEventListener("click", () => {
                this.accept();
                this.hide();
            }, false);
            element.addEventListener("keydown", function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    element.click();

                }
            });
        });
    }

    html(config) {
        return `
<div class="cookie-consent-settings" tabindex=0>
    <h2 class="cookie-consent-settings__header">${config.header}</h2>
    <div class="cookie-consent-settings__description">${config.text}</div>
    <div class="cookie-consent-settings__categories">${this.settingsHtml()}</div>
    <div class="cookie-consent-settings__footer">
        <a tabindex=0 class="${acceptSettingsClass}">${config.acceptText}</a>
        <a class="cookie-consent-settings__legal-notice-link" href="${config.legalNoticeLink}">
            ${config.legalNoticeText}
        </a>
    </div>
</div>
`;
    }

    isChecked(category) {
        if (category.name === "required") {
            return "checked";
        }

        // User has previously accepted the category
        if (this.status.isAccepted(category.name)) {
            return "checked";
        }
        // User has not selected anything, but the category is selected by default
        if (!this.status.hasSelected() && category.acceptedByDefault === true) {
            return "checked";
        }
        return "";
    }

    settingsHtml() {
        let html = "";

        this.cookieCategories.forEach((setting) => {
            const checked = this.isChecked(setting);

            const disabled = setting.name === "required" ? "disabled" : "";

            const id = `cookie-consent-settings-${setting.name}`;
            // eslint-disable-next-line max-len
            const checkbox = `<input type="checkbox" ${checked} ${disabled} class="cookie-settings__category-selection" aria-labelledby="cookies" id="${id}" name="${id}" value="${setting.name}">`;
            html += `
<div class="cookie-consent-settings__category">
    <label class="cookie-consent-settings__switch">${checkbox}
        <span class="cookie-consent-settings__slider round"></span>
    </label>
    <div class="cookie-consent-settings__category-description">
        <h3>${setting.displayName}</h3><p>${setting.description}</p>
    </div>
</div>`;
        });
        return html;
    }

    hide() {
        document.getElementById(settingsWindowId).remove();
    }

    accept() {
        const selections = Array.prototype.slice.call(document.querySelectorAll(
            ".cookie-consent-settings__categories input[type='checkbox'].cookie-settings__category-selection",
        ));
        selections.forEach((element) => {
            const categoryName = element.value;
            if (element.checked) {
                this.status.accept(categoryName);
            } else {
                this.status.decline(categoryName);
            }
        });
    }
}
